import React, { useEffect, useState } from 'react';
import './ShimmerMenu.scss';

type ShimmerMenuListProps = {
    rowHeight?: number;
    reducedRows?: number;
};

const ShimmerMenuList: React.FC<ShimmerMenuListProps> = ({ rowHeight, reducedRows }) => {
    const SHIMMER_ITEM_HEIGHT = rowHeight ?? 30; //HEIGHT OF THE ROW
    const childHeight = SHIMMER_ITEM_HEIGHT - 12; //HEIGHT WITHOUT PADDING
    const [itemCount, setItemCount] = useState(3);

    //BASED ON CONTAINER SIZE GET COUNT OF ROWS
    useEffect(() => {
        const updateCount = () => {
            const availableHeight = window.innerHeight - 100; // adjust if header/footer present
            const count = Math.floor(availableHeight / SHIMMER_ITEM_HEIGHT);
            setItemCount(count - (reducedRows ?? 6));
        };

        updateCount();
        window.addEventListener('resize', updateCount);
        return () => window.removeEventListener('resize', updateCount);
    }, [rowHeight]);

    return (
        <div className="shimmer-menu-list">
            <div>
                {Array.from({ length: itemCount }).map((_, i) => (
                    <div className="shimmer-item" key={i} style={{ height: SHIMMER_ITEM_HEIGHT }}>
                        <div className="shimmer-item-child" style={{ height: childHeight }} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ShimmerMenuList;